import { GenericService } from '../GenericService'

class BusinessSerService extends GenericService {
    constructor() {
        super('/api/services')
    }

    adminBusinessServices = (query) =>
        this.post('/api/services/adminBusinessServices', {
            query,
        })
}

export default new BusinessSerService()
